var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "plainform" }, [
    _c("div", { staticClass: "plainform__content trs" }, [
      _c("h2", { staticClass: "modal__title t-h2 clr-blue-7" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      !_vm.isSuccess
        ? _c(
            "form",
            {
              staticClass: "js-form modal__form",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.formSubmit.apply(null, arguments)
                },
              },
            },
            [
              _vm._l(_vm.fields, function (item) {
                return _c(_vm.getComponentByType(item.component), {
                  key: item.id,
                  tag: "component",
                  attrs: { item: item },
                  model: {
                    value: _vm.updateField,
                    callback: function ($$v) {
                      _vm.updateField = $$v
                    },
                    expression: "updateField",
                  },
                })
              }),
              _c(
                "button",
                {
                  staticClass:
                    "modal__submit btn btn--outline btn-submit clr-blue-10",
                  class: { active: _vm.isSuccess },
                  attrs: { type: "submit", "data-text": "", submit: "" },
                },
                [_vm._v(_vm._s(_vm.sendText))]
              ),
              _vm.errors.length
                ? _c("div", { staticClass: "form-error" }, [
                    _vm._v(_vm._s(_vm.error)),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.isSuccess
        ? _c("div", {
            staticClass: "success-message",
            domProps: { innerHTML: _vm._s(_vm.successText) },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }